import { Address } from '@/models/address';

export interface PatientModel {
  $id?: string;
  address: null | Address;
  temporaryAddress: null | Address;
  email: string;
  name: string;
  socialSecurityNo: string;
  phoneNo: string;
  treatmentMeta: TreatmentMeta;
  $factorConcentrateApplied: string[];
  $isRegisteredUser?: boolean;
  $doctorId?: null | string;
  $centerId?: null | string;
  $updatedAt?: Date;
  $createdAt?: Date;
}

export interface TreatmentMeta {
  associatedDiseaseConditions: AssociatedDiseaseCondition[];
  additionalDiseaseConditions: string,
  birthdate?: Date;
  bloodType?: BloodType;
  weight?: number;
  concomittantMedication: string;
  diagnosis: string;
  drugAllergy: string;
  factorActivities?: RealFactorActivity[];
  inhibitor?: boolean;
  inhibitorUnit?: number;
  irregularAntibodies?: boolean;
  methodOfTreatment?: TreatmentMethod;
  targetJoints?: TargetJoints;
  targetJointTypes?: TargetJointTypes[];
  otherTargetJoint?: string;
  movementActivity?: MovementActivity;
  walkingAid?: boolean;
}

export type RealFactorActivity = {
  factor: FactorActivity;
} & FactorLevel;

export interface FactorLevel {
  op: FactorLevelOperator,
  value: number,
  severity?: 'mild' | 'moderate' | 'severe'
}

export enum FactorLevelSeverity {
  Mild = 'mild',
  Moderate = 'moderate',
  Severe = 'severe',
}

export type FactorLevelOperator = 'eq' | 'lte';

export enum AssociatedDiseaseCondition {
  HepatitisA = 'hepatitis-a',
  HepatitisB = 'hepatitis-b',
  HepatitisC = 'hepatitis-c',
  Other      = 'other',
}

export enum BloodType {
  ABM   = 'ab-',
  ABP   = 'ab+',
  AM    = 'a-',
  AP    = 'a+',
  BM    = 'b-',
  BP    = 'b+',
  OM    = '0-',
  OP    = '0+',
  Other = 'other',
}

export enum FactorActivity {
  Willebrand = 'willebrand',
  V          = 'v',
  VII        = 'vii',
  IX         = 'ix',
  X          = 'x',
  XIII       = 'xiii',
}

export enum TreatmentMethod {
  Profilaxis = 'profilaxis',
  OnDemand = 'ondemand',
  ImmuneToleranceInduction = 'immune_tolerance_induction',
}

export enum TargetJoints {
  None = 'none',
  One = 'one',
  Multiple = 'multiple',
}

export enum TargetJointTypes {
  RightShoulder = 'right_shoulder',
  LeftShoulder = 'left_shoulder',
  RightElbow = 'right_elbow',
  LeftElbow = 'left_elbow',
  RightWrist = 'right_wrist',
  LeftWrist = 'left_wrist',
  RightHip = 'right_hip',
  LeftHip = 'left_hip',
  RightKnee = 'right_knee',
  LeftKnee = 'left_knee',
  RightAnkle = 'right_ankle',
  LeftAnkle = 'left_ankle',
  OtherJoint = 'other_joint',
}

export enum MovementActivity {
  None = 'none',
  SlightlyLimited = 'slightly_limited',
  HighlyLimited = 'highly_limited',
  AssistanceNeeded = 'assistance_needed',
}
